import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import ActivitiesInner from '../Components/Activities/ActivitiesInner'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import { usePageBanner } from '../hooks/usePageBanner'

function Activities() {
    const { title, bgImage } = usePageBanner({
        pageSlug: 'activities',
        fallbackTitle: 'Activities',
    })

    return (
        <>
            <HeaderOne />
            <Breadcrumb title={title} bgImage={bgImage} />
            <ActivitiesInner />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default Activities
